import { Injectable, ElementRef, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, BehaviorSubject, throwError, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable()
export class AppService {

  private _coreServiceUrl = this._utilService.hostUrl;
  private _coreAuthServiceUrl = this._coreServiceUrl + 'Auth/';
  //private _coreAuthServiceUrl = "https://localhost:44314/" + 'Auth/';
  //Local IIS
  //private _coreAuthServiceUrl = "http://localhost/S3ServiceResetPassword/" + 'Auth/';
  //UAT IIS
  // private _coreAuthServiceUrl = this._coreServiceUrl+'Auth/';
  //private _coreAuthServiceUrl = "http://uatblacklight.s3partners.net/S3CoreAPI/" + 'Auth/';

  constructor(private httpClient: HttpClient, public router: Router, private _utilService: UtilService) {

  }
  public sendOtpToUser(username: string, otp: string, productId: string): Observable<any> {
    const secret = 'S3#BL$%#%2025'; // Must match the value in your appsettings.json
    const now = new Date();
    const ticks = now.getTime(); // Milliseconds since epoch (UTC)
    const token = `${secret}:${ticks}`;
    const url = `${this._coreAuthServiceUrl}SendOtpToUser?token=${encodeURIComponent(token)}`;
    const body = { Username: username, Otp: otp, ProductId: productId };
    return this.httpClient.post<any>(url, body);
  }
  public resetPasswordApi(resetPassword: any): Observable<{ Success: boolean }> {
    const url = this._coreAuthServiceUrl + 'ResetPassword';
    return this.httpClient.post<{ Success: boolean }>(url, resetPassword);
  }
  // public sendOtpApi(request: { ToEmail: string, Otp: string }): Observable<{ Success: boolean, Message: string }> {
  //   const url = this._coreAuthServiceUrl + 'SendOtp';
  //   return this.httpClient.post<{ Success: boolean, Message: string }>(url, request);
  // }  
  public addUserOTPRequestInfo(userId: string, productId: string, trackerType: string): Observable<any> {
    const url = `${this._coreAuthServiceUrl}AddUserOTPRequestInfo`;
    const params = { userId, productId, trackerType };
    return this.httpClient.post<any>(url, null, { params });
  }
  public getUserInfo(Username: string): Observable<any> {
    // Token logic must match backend
    const secret = 'S3#BL$%#%2025'; // Should match backend config
    const now = new Date();
    const ticks = now.getTime();
    const token = `${secret}:${ticks}`;
    const url = `${this._coreAuthServiceUrl}GetUserInfo`;
    const params = { Username, token };
    return this.httpClient.get<any>(url, { params });
  }
}


